import Stack from '@mui/material/Stack';
import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { blue } from '@material-ui/core/colors/';
import GroupsIcon from '@mui/icons-material/Groups';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import api_data from '../../data/TableData';

let products = api_data['all_products']
let companyNameArray = []
let b = []

function checkUp(props) {
  let c = companyNameArray.length
  for (let i = 0; i < c; i++) {
    if (props === companyNameArray[i]) {
      b[i] = props
      break
    }
  }
}
products.map((row, i) => (
  companyNameArray[i] = row.company,
  checkUp(companyNameArray[i])
))

let companyClientNumber = b.filter(n => n).length
let companyClientName = b.filter(n => n)



const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  backgroundColor: blue[500],
  '&:hover': {
    backgroundColor: blue[800],
  },
}));




export default function CustomizedButtons() {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Stack spacing={2} direction="row">
      <ColorButton
        style={{ minWidth: '100%', minHeight: '3.125rem' }}
        startIcon={<GroupsIcon></GroupsIcon>}
        onClick={handleClickOpen}
        size="larger" variant="contained">Numero de Clientes: {companyClientNumber}
      </ColorButton>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Lista de clientes"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <List
              md={{
                width: '100%',
                maxWidth: 460,
                bgcolor: 'background.paper',
                position: 'relative',
                overflow: 'auto',
                maxHeight: 300,
                '& ul': { padding: 0 },
              }}
              subheader={<li />}
            >
              {companyClientName.map((sectionId) => (
                <li key={`section-${sectionId}`}>
                  <ul>
                    <ListItem key={`item-${sectionId}`}>
                      <ListItemText primary={`${sectionId}`} />
                    </ListItem>
                  </ul>
                </li>
              ))}
            </List>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
}